
import { actions } from '@/Utils/folders'

import Button from '@/components/UntitledUI/Button.vue'
import CreateFolderModal from '@/components/Folders/Modals/CreateFolderModal'
import TrashNodeModal from '@/components/Folders/Modals/TrashNodeModal'
import DeleteNodeModal from '@/components/Folders/Modals/DeleteNodeModal'
import RenameNodeModal from '@/components/Folders/Modals/RenameNodeModal'
import MoveNodeModal from '@/components/Folders/Modals/MoveNodeModal'
import FilesystemPath from '@/components/Folders/Path/FilesystemPath'
import FilesystemActions from '@/components/Folders/FilesystemActions'
import FilesContextMenu from '@/components/Folders/Menus/FilesContextMenu'
import FoldersContextMenu from '@/components/Folders/Menus/FoldersContextMenu'
import FilesystemNode from '@/components/Folders/Nodes/FilesystemNode'
import FilesystemNodesHeader from '@/components/Folders/FilesystemNodesHeader'
import Pagination from '@/components/Folders/Pagination'
import FilesystemNodeSkeleton from '@/components/Folders/Nodes/FilesystemNodeSkeleton'
import ShowNodeInfoModal from '@/components/Folders/Modals/ShowNodeInfoModal'
import BulkContextMenu from '@/components/Folders/Menus/BulkContextMenu'
import RootFolders from '@/components/Folders/RootFolders'

export default {
    name: 'Filesystem',
    components: {
        RootFolders,
        BulkContextMenu,
        ShowNodeInfoModal,
        FilesystemNode,
        FilesContextMenu,
        FoldersContextMenu,
        FilesystemNodesHeader,
        FilesystemNodeSkeleton,
        FilesystemActions,
        FilesystemPath,
        MoveNodeModal,
        RenameNodeModal,
        TrashNodeModal,
        DeleteNodeModal,
        CreateFolderModal,
        Button,
        Pagination
    },
    props: {
        nodes: {
            type: Array,
            default: () => []
        },
        folder: {
            type: Object,
            default: null
        },
        roots: {
            type: Array,
            required: true
        },
        pagination: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            modal: null,
            node: null,
            page: 1,
            input: ''
        }
    },
    computed: {
        selectedNodes () {
            return this.$store.getters['folders/selectedNodes']
        }
    },
    watch: {
        page (page) {
            this.$emit('update-params', { page })
        }
    },
    mounted () {
        this.page = this.pagination?.current || 1
    },
    methods: {
        performAction ({ action, data, node }) {
            const func = actions[data.func]
            if (typeof func === 'function') {
                func(action, data.params, node, this)
            }
        },
        closeModal () {
            this.modal = ''
            this.input = ''
            this.$refs.filesMenu.close()
            this.$refs.folderMenu.close()

            // if drag was going (or not), end it
            this.$store.commit('folders/endDrag')
        },
        openMenu (e, node) {
            if (!this.selectedNodes.includes(node.id)) {
                this.$store.commit('folders/clearSelectedNodes')
                if (node.node_type === 'd') {
                    this.$refs.folderMenu.open(e, node)
                } else {
                    this.$refs.filesMenu.open(e, node)
                }
            } else if (this.selectedNodes.length === 1) {
                if (node.node_type === 'd') {
                    this.$refs.folderMenu.open(e, node)
                } else {
                    this.$refs.filesMenu.open(e, node)
                }
            } else {
                this.$refs.bulkMenu.open(e)
            }
        },
        selectAll (value) {
            this.$store.commit('folders/clearSelectedNodes')
            if (value) {
                for (const node of this.nodes) {
                    this.$store.commit('folders/addSelectedNode', node.id)
                }
            }
        },
        createFolder (name, dialog) {
            if (dialog) {
                this.modal = 'create-folder'
                return
            }
            this.$emit('create-folder', { name, folder: this.folder?.id })
            this.closeModal()
        },
        showNode (node, newWindow) {
            if (this.$store.getters['folders/selectedNodes'].length > 0) {
                this.$store.commit('folders/clearSelectedNodes')
                return
            }

            if (node.node_type === 'd') {
                this.listFolder(node)
            } else if (node?.data?.type === 'qanoniah_file') {
                if (newWindow) {
                    window.open(this.localePath('/File/' + node.data.extra.hash), '_blank')
                } else {
                    this.$router.push(this.localePath('/File/' + node.data.extra.hash))
                }
            } else if (node?.data?.type === 'qanoniah_contract') {
                if (newWindow) {
                    window.open(this.localePath('/Contract/' + node.data.extra.hash), '_blank')
                } else {
                    this.$router.push(this.localePath('/Contract/' + node.data.extra.hash))
                }
            }
        },
        selectNode (node, value) {
            if (value) {
                this.$store.commit('folders/addSelectedNode', node.id)
            } else {
                this.$store.commit('folders/removeSelectedNode', node.id)
            }
        },
        showNodeInFolder (node) {
            this.$emit('show-in-folder', node)
        },
        showNodeInfo (node) {
            this.node = node
            this.modal = 'node-info'
        },
        renameNode ({ node, name }, dialog) {
            if (dialog) {
                this.modal = 'rename-node'
                this.node = node
                return
            }

            this.$emit('rename-folder', { id: node.id, name })
            this.closeModal()
        },
        moveNode (node, dialog, drag) {
            if (dialog) {
                this.modal = 'move-node'
                this.node = node
                return
            }
            if (drag) {
                this.node = node
                this.$store.commit('folders/startDrag')
                // if dragged node not in selected nodes, then deselect all
                if (!this.$store.getters['folders/selectedNodes'].includes(node.id)) {
                    this.$store.commit('folders/clearSelectedNodes')
                }
                return
            }

            // if drag was going (or not), end it
            this.$store.commit('folders/endDrag')

            if (this.node?.id === node?.id || node?.node_type === 'f') {
                return
            }
            this.$emit('move-node', { node: this.node, folder: node?.id })
            this.closeModal()
        },
        copyNode (node, dialog) {
            if (dialog) {
                this.modal = 'copy-node'
                this.node = node
                return
            }

            if (this.node?.id === node?.id) {
                return
            }
            this.$emit('copy-node', { node: this.node, folder: node?.id })
            this.closeModal()
        },
        trashNode (node, dialog) {
            if (dialog) {
                this.modal = 'trash-node'
                this.node = node
                return
            }
            this.$emit('trash-node', node)
            this.closeModal()
        },
        restoreNode (node) {
            this.$emit('restore-node', node)
            this.closeModal()
        },
        deleteNode (node, dialog) {
            if (dialog) {
                this.modal = 'delete-node'
                this.node = node
                return
            }
            this.$emit('delete-node', node)
            this.closeModal()
        },
        search (text) {
            this.$emit('search', text)
        },
        listFolder (fsNode) {
            const id = fsNode?.id ? fsNode.id : null
            this.$emit('show-folder', id)
            this.closeModal()
        },
        refresh () {
            this.$emit('refresh')
        }
    }
}
